import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Popup from 'reactjs-popup';

import { JOIN_SOUND } from '../../api/agoraApi';
import css from '../../css/common/joinPopup.module.scss';
import { ReactComponent as Cross } from '../../img/common/cross.svg';
import { ChatGroup } from '../../model/chatGroup';
import { ChatGroupRoom } from '../../model/chatGroupRoom';
import { updateRooms } from '../../slice/chatGroupSlice';

import { selectUser } from '../../slice/userSlice';
import { joinRoom, leaveRoom, selectVoiceCall } from '../../slice/voiceCallSlice';

export const JoinPopup: React.FC<{ group: ChatGroup; room: ChatGroupRoom; trigger: JSX.Element }> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { entity: user } = useSelector(selectUser);
    const { onCall, room, group } = useSelector(selectVoiceCall);
    // loading is for preventing user from double clicks
    const [loading, setLoading] = useState(false);

    const transitionRoomScreen = async () => {
        if (user === null) {
            return;
        }
        if (loading) {
            return;
        }
        setLoading(true);
        // play a short blank audio for enabling Safari to play sound automatically
        // https://medium.com/@curtisrobinson/how-to-auto-play-audio-in-safari-with-javascript-21d50b0a2765
        JOIN_SOUND.play().catch((err) => console.log(err));
        JOIN_SOUND.pause();

        if (onCall && group !== undefined && room !== undefined) {
            await dispatch(leaveRoom({ groupId: group.id, roomId: room.id }));
            dispatch(updateRooms({ groupId: group.id, roomIds: [room.id] }));
        }
        await dispatch(joinRoom({ group: props.group, room: props.room, userId: user.id }));
        dispatch(updateRooms({ groupId: props.group.id, roomIds: [props.room.id] }));

        history.push(`/groups/${props.group.id}/rooms/${props.room.id}`);
    };

    return (
        <Popup trigger={props.trigger} modal nested overlayStyle={{ background: 'rgba(0, 0, 0, 0.7)' }}>
            {(close: () => void) => (
                <div className={css.popup}>
                    <div className={css.title}>
                        ボイチャルームに入りますか？
                        <Cross height={24} width={24} onClick={close} role="img" aria-label="閉じる" />
                    </div>
                    <div className={css.content}>
                        <span onClick={() => close()}>キャンセル</span>
                        <span onClick={() => transitionRoomScreen()}>通話に入る</span>
                    </div>
                </div>
            )}
        </Popup>
    );
};
